import { Box, Typography } from "@outschool/backpack";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { Activity } from "@outschool/gql-backend-generated";
import { Banner } from "@outschool/ui-legacy-component-library";
import lodashIsEmpty from "lodash/isEmpty";
import React from "react";

export default function Disclaimer({ text }: { text: Activity["disclaimer"] }) {
  if (lodashIsEmpty(text)) {
    return null;
  }

  return (
    <Box
      sx={{
        marginTop: "1em",
      }}
    >
      <Banner round variant="warning" sx={{ mb: "small" }}>
        <Typography
          variant="inherit"
          sx={{
            fontStyle: "italic",
          }}
        >
          {text}
        </Typography>
      </Banner>
    </Box>
  );
}
